import React from 'react';
import { Ellipse } from '@bubble-ui/primitive-ellipse';
import { Surface } from '@bubble-ui/primitive-surface';
var Bullet = _ref => {
  var {
    color,
    fontSize,
    fontWeight = 400
  } = _ref;
  var viewBoxSize = Math.ceil(fontSize / 3);
  // Circle Size is linear to fontSize and fontWeight
  var circleSize = fontSize / 6 * (fontWeight / 2000 + 0.6);
  return /*#__PURE__*/React.createElement(Surface, {
    fill: color,
    viewBox: "0 0 ".concat(viewBoxSize, " ").concat(viewBoxSize),
    width: viewBoxSize,
    height: viewBoxSize
  }, /*#__PURE__*/React.createElement(Ellipse, {
    cx: viewBoxSize / 2,
    cy: viewBoxSize / 2,
    fill: color,
    rx: circleSize,
    ry: circleSize
  }));
};
Bullet.displayName = 'Bullet';
export { Bullet };
//# sourceMappingURL=Bullet.js.map